/** @file briefCamera: the camera paragraph of an art brief: the profile pitch and the facing legend. */
import type { ArtBriefProfile } from './artBriefOf';

/** `## Camera` with the pitch (or "given on each line" when unknown) and what the facing degrees mean. */
export function briefCamera(profile: ArtBriefProfile): string[] {
  const pitch = profile.pitchDeg === null
    ? ['The camera pitch is given on each line.']
    : [`The camera looks down from ${String(profile.pitchDeg)} degrees above the horizon (profile \`${profile.id}\`),`, 'orthographic: no perspective.'];
  return ['## Camera', '', ...pitch,
    'Facing: 0 deg = toward the viewer, 90 = turned to face screen-left, 180 = the back,', '270 = turned to face screen-right.'];
}
